import { ActionError, PromisifiedActionMeta } from 'Interfaces/ActionCreators';
import { RequestHistoryData, RequestHistoryGetPayload } from 'Interfaces/RequestsHistory';
import { createAsyncAction } from 'typesafe-actions';
import { promisifyAsyncAction } from 'Utils/functions';

import { RequestHistoryGetActionTypes } from './actionTypes';

export const getRequestHistory = createAsyncAction(
  RequestHistoryGetActionTypes.request,
  RequestHistoryGetActionTypes.success,
  RequestHistoryGetActionTypes.failure,
  RequestHistoryGetActionTypes.cancel,
)<
  [RequestHistoryGetPayload, PromisifiedActionMeta],
  [RequestHistoryData, PromisifiedActionMeta],
  [ActionError, PromisifiedActionMeta],
  [undefined, PromisifiedActionMeta]
>();

export const $getRequestHistory = promisifyAsyncAction(getRequestHistory);
